import { createStore } from 'vuex'

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  alert: {
    show: false,
    color: "success",
    duration: 5000,
    message: "",
  },
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  setAlert(state, config) {
    state.alert = { ...state.alert, ...config, show: true };
  },
  hideAlert() {
    state.alert.show = false;
  },
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default createStore({
  state,
  mutations
})
